import { DotsThreeVertical } from "@phosphor-icons/react";
import { DropdownMenu, IconButton } from "@radix-ui/themes";
import cx from "classnames";

import { isNil } from "../../../utils/fp";

type TicketActionsDropdownProps = {
  className?: string;
  onDeleteTicket(): void;
  onRename?: () => void;
  onShare(): void;
  onDownload(): void;
  onManageVersions?: () => void;
  triggerIcon?: React.ReactNode;
};

export function TicketActionsDropdown(props: TicketActionsDropdownProps) {
  const {
    className,
    onDeleteTicket,
    onRename,
    onShare,
    onDownload,
    onManageVersions,
    triggerIcon,
  } = props;

  return (
    <DropdownMenu.Root data-testid="ticket-actions-dropdown">
      <DropdownMenu.Trigger
        className={className}
        data-testid="ticket-actions-dropdown-trigger"
      >
        <IconButton size="1" variant="ghost" color="gray">
          {triggerIcon ?? (
            <DotsThreeVertical
              size={16}
              weight="bold"
              className="text-on-surface"
            />
          )}
        </IconButton>
      </DropdownMenu.Trigger>

      <DropdownMenu.Content
        data-testid="ticket-actions-dropdown-content"
        collisionPadding={16}
        className="max-h-[min(70vh,420px)] overflow-y-auto"
      >
        <DropdownMenu.Item
          onClick={(e) => {
            e.stopPropagation();
            onShare();
          }}
          className="text-on-surface radix-highlight:bg-accent radix-highlight:text-on-accent cursor-pointer"
          data-testid="ticket-action-share"
        >
          Share
        </DropdownMenu.Item>
        <DropdownMenu.Item
          onClick={(e) => {
            e.stopPropagation();
            if (onRename) onRename();
          }}
          className={cx(
            "text-on-surface radix-highlight:bg-accent radix-highlight:text-on-accent cursor-pointer",
            {
              hidden: !onRename,
            },
          )}
          data-testid="ticket-action-rename"
        >
          Rename
        </DropdownMenu.Item>
        <DropdownMenu.Item
          onClick={(e) => {
            e.stopPropagation();
            onDownload();
          }}
          className="text-on-surface radix-highlight:bg-accent radix-highlight:text-on-accent cursor-pointer"
          data-testid="ticket-action-download"
        >
          Download
        </DropdownMenu.Item>
        <DropdownMenu.Item
          onClick={(e) => {
            e.stopPropagation();

            if (!isNil(onManageVersions)) {
              onManageVersions();
            }
          }}
          className={cx(
            "text-on-surface radix-highlight:bg-accent radix-highlight:text-on-accent cursor-pointer",
            {
              hidden: isNil(onManageVersions),
            },
          )}
          data-testid="ticket-action-manage-versions"
        >
          Manage Versions
        </DropdownMenu.Item>
        <DropdownMenu.Item
          onClick={(e) => {
            e.stopPropagation();
            onDeleteTicket();
          }}
          className="text-on-surface radix-highlight:bg-accent radix-highlight:text-on-accent cursor-pointer"
          data-testid="ticket-action-delete"
        >
          Delete
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
